import { render, staticRenderFns } from "./LoadingPage.vue?vue&type=template&id=a3fc29aa&"
var script = {}
import style0 from "./LoadingPage.vue?vue&type=style&index=0&id=a3fc29aa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports